<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.type"
        placeholder="人物类型"
        clearable
      >
        <el-option
          v-for="(item, i) in personTypes"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.isImportant"
        placeholder="重点人物"
        clearable
      >
        <el-option label="是" :value="1"></el-option>
        <el-option label="否" :value="0"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="姓名/描述信息"
        clearable
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import { collegeSimpleFullList } from "@/api/dept";
import butn from "@/components/button/index";
export default {
  components: {
    butn,
  },
  data() {
    return {
      filters: {
      },
      personTypes: [],

    };
  },
  created() {
    this.getSysParamByTypes(["PERSON_SAMPLE_TYPE"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.personTypes = res.data["PERSON_SAMPLE_TYPE"] || [];
      });
    },
    initData() {
      this.$emit("search", { ...this.filters });
    },
    resetData() {
      this.filters = {};
      this.$emit("search", {});
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-select__tags {
  overflow: hidden;
  span {
    display: flex;
  }
}
</style>
